export const cookies = {
	setCookies:function(userKey, userToken, time) {
		var expire = new Date();

		var userCookie = userKey;
		//today.getTime() + 60 * 60 * 1000 * 24 * number_of_days
		expire.setTime(expire.getTime() + time * 3600 * 1000);
		document.cookie = userCookie + "=" + escape(userToken) + "; expires=" + expire.toGMTString() + "; path=/; domain=.emforce.co.kr;";
	},
	getCookies:function(userKey) {
		var userCookie = userKey;
		var returnValue = null;

		var cookie_list = document.cookie.split(';');
		var cookie_map = {}
		for(var i=0; i <cookie_list.length; i++){
			var temp = cookie_list[i].split('=');
			cookie_map[temp[0].replace(' ','')] = temp[1];
		}
		returnValue = cookie_map[userCookie];
		
		return returnValue;
	}
}



// WEBPACK FOOTER //
// ./js/controller/assets/lib/cookies.js